"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Watch = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Watch = function Watch(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", {
      width: props.width,
      height: props.height,
      version: "1.1",
      id: "L2",
      xmlns: "http://www.w3.org/2000/svg",
      x: "0px",
      y: "0px",
      viewBox: "0 0 100 100",
      enableBackground: "new 0 0 100 100",
      xmlSpace: "preserve",
      "aria-label": props.label
    },
    /*#__PURE__*/
    _react["default"].createElement("circle", {
      fill: "none",
      stroke: props.color,
      strokeWidth: "4",
      strokeMiterlimit: "10",
      cx: "50",
      cy: "50",
      r: props.radius
    }),
    /*#__PURE__*/
    _react["default"].createElement("line", {
      fill: "none",
      strokeLinecap: "round",
      stroke: props.color,
      strokeWidth: "4",
      strokeMiterlimit: "10",
      x1: "50",
      y1: "50",
      x2: "85",
      y2: "50.5"
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      attributeName: "transform",
      dur: "2s",
      type: "rotate",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })),
    /*#__PURE__*/
    _react["default"].createElement("line", {
      fill: "none",
      strokeLinecap: "round",
      stroke: props.color,
      strokeWidth: "4",
      strokeMiterlimit: "10",
      x1: "50",
      y1: "50",
      x2: "49.5",
      y2: "74"
    },
    /*#__PURE__*/
    _react["default"].createElement("animateTransform", {
      attributeName: "transform",
      dur: "15s",
      type: "rotate",
      from: "0 50 50",
      to: "360 50 50",
      repeatCount: "indefinite"
    })))
  );
};

exports.Watch = Watch;
Watch.propTypes = {
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  color: _propTypes["default"].string,
  label: _propTypes["default"].string,
  radius: _propTypes["default"].number
};
Watch.defaultProps = {
  height: 80,
  width: 80,
  color: "green",
  label: "audio-loading",
  radius: 48
};